import OrigenDeudaShow from './OrigenDeudaShow'
export {OrigenDeudaShow}
export default OrigenDeudaShow
